// Much of the fuctionality adapted from:
// https://medium.com/@lucas.eckman/ditch-the-carousel-creating-a-horizontal-scroll-effect-7a36c0f1c456

import { getHeaderHeight } from './utilities';
import { useState } from './use-state-sim';

(($) => {
  $(() => {
    const $storytellers = $('.section--storyteller');

    if ($storytellers.length) {
      $storytellers.each((index, element) => {
        const $section = $(element);
        const $slides = $section.find('.storyteller__slide');

        // Reproduced React hooks in vanilla JS.
        const [dynamicHeight, setDynamicHeight] = useState(null);
        const [translateX, setTranslateX] = useState(0);

        const imageTriggerOffset = 300;

        const $storytellerSticky = $section.find('.storyteller__sticky');
        const $storytellerScrollable = $section.find('.storyteller__scrollable');
        const $storytellerWrapper = $section.find('.storyteller__wrapper');

        const calcDynamicHeight = (objectWidth) => {
          const vw = window.innerWidth;
          const vh = window.innerHeight;
          return objectWidth - vw + vh;
        };

        const handleDynamicHeight = ($ref, setDynamicHeight) => {
          if (window.innerWidth >= 993) {
            const ref = $ref[0];
            const objectWidth = ref.scrollWidth;
            const dynamicHeight = calcDynamicHeight(objectWidth);
            setDynamicHeight(dynamicHeight);
            const headerHeight = getHeaderHeight();

            $storytellerWrapper.css('height', dynamicHeight - headerHeight);
            $storytellerSticky.css('top', headerHeight);
          } else {
            $storytellerWrapper.css('height', 'initial');
          }
        };

        const animateSlides = (offsetTop, boundingTop) => {
          if (null === offsetTop || null === boundingTop || !$slides.length) {
            return;
          }

          if (offsetTop < 0) {
            $slides.each((index, element) => {
              const $slide = $(element);
              if ($slide[0].offsetLeft < -(offsetTop - imageTriggerOffset)) {
                $slide.find('.storyteller__image-wrapper').addClass('storyteller__image-wrapper--active');
              }
            });
          }
        };

        const applyScrollListener = ($ref, setTranslateX) => {
          const ref = $ref[0];

          const scrollHandler = () => {
            const offsetTop = -ref.offsetTop;
            const boundingTop = ref.getBoundingClientRect().top;

            setTranslateX(offsetTop);

            $storytellerScrollable.css('transform', 'translateX(' + String(translateX()) + 'px)');

            animateSlides(offsetTop, boundingTop);
          };

          if (window.innerWidth >= 993) {
            window.addEventListener('scroll', scrollHandler);
          } else {
            window.removeEventListener('scroll', scrollHandler);
          }
        };

        const resizeHandler = () => {
          handleDynamicHeight($storytellerScrollable, setDynamicHeight);
        };

        const storytellerInit = () => {
          handleDynamicHeight($storytellerScrollable, setDynamicHeight);
          applyScrollListener($storytellerSticky, setTranslateX);
        }

        window.addEventListener('resize', resizeHandler);
        window.addEventListener('resize', storytellerInit);

        storytellerInit();
      });
    }
  });
})(jQuery);
